import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BreadcrumbService } from 'xng-breadcrumb';
import { SubHeaderService } from '../../../../../shared/store/subheader/subheader.service';
import { View } from '../../../../../shared/store/view/types';
import { ViewService } from '../../../../../shared/store/view/views.service';
import { WorkLocationService } from '../../../../../shared/store/attendance/work-location/work-location.service';
import { WorkLocationModel } from '../../../../../shared/store/attendance/work-location/types';

@UntilDestroy()
@Component({
  selector: 'app-work-location-details',
  standalone: false,
  templateUrl: './work-location-details.component.html',
  styleUrl: './work-location-details.component.scss',
})
export class WorkLocationDetailsComponent implements OnInit, OnDestroy {
  workLocationId: number;
  workLocation$: Observable<WorkLocationModel>;
  view$: Observable<View>;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly workLocationService: WorkLocationService,
    private readonly subHeaderService: SubHeaderService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly viewService: ViewService,
  ) {
    this.workLocation$ = this.workLocationService.getById.value$;
    this.view$ = this.viewService.getViews.value$;
  }

  ngOnInit(): void {
    this.workLocationId = this.route.snapshot.params['id'];
    this.workLocationService.getById.call(this.workLocationId);

    this.workLocation$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@workLocationDetails', x.name);
      });

    this.view$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@list', x.title);
      });

    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'workLocationEdit') {
          this.router.navigate([
            '/Configuration/WorkLocations/Edit',
            this.workLocationId,
          ]);
        }
        this.subHeaderService.setTriggerAction('');
      });
  }

  ngOnDestroy(): void {
    this.workLocationService.getById.reset();
    this.breadcrumbService.set('@workLocationDetails', ' ');
  }
}
